import { datadogRum } from '@datadog/browser-rum';
import { env, isDev } from 'config/env';

export class ErrorHandler {
    public initialize = () => {
        datadogRum.init({
            applicationId: env.DATADOG_APPLICATION_ID,
            clientToken: env.DATADOG_CLIENT_TOKEN,
            service: 'frontend',
            env: env.ENVIRONMENT,
            site: 'us3.datadoghq.com',
            version: env.REACT_APP_VERSION,
            trackUserInteractions: true,
            trackResources: true,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            sessionPersistence: 'local-storage',
            useSecureSessionCookie: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
        });
    };

    public handleError = (err: unknown) => {
        if (isDev) {
            console.error(err);
        }
        datadogRum.addError(err);
    };
}

export default new ErrorHandler();
